// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1InLr","left":"styles_left__m1AfN","right":"styles_right__2lTD3","alert":"styles_alert__Lm1JI"};